import React, { useEffect, useState } from "react";
import useCategoryStore from "../../../Stores/useCategoryStore";
import styles from "./CategorySelector.module.css";
import { handleImgError } from "../../Shared/ImageError";
import { useMediaQuery } from "react-responsive";
import MHCarousel from "../../Shared/MHCarousel/MHCarousel";
import CategorySelectorItem from "./CategorySelectorItem";


function CategorySelector({ categorySelected, selectedCategory }) {
  const { categories, getCategories, setSelectedCategory } = useCategoryStore();
  useEffect(() => {
    if (categories.length === 0) {
      const fetchCategories = async () => {
        await getCategories();
      };
      fetchCategories();
    }
  }, [categories]);

  const handleCategoryClick = (category) => {
    if (selectedCategory === category) {
      // setSelectedCategory(null);
      categorySelected(null);
      return;
    }
    // setSelectedCategory(category);
    categorySelected(category);
  };

  const isMobile = useMediaQuery({ maxWidth: 1024 });


const [selectedIndex, setSelectedIndex] = useState(0);

const categoryList = () => {
    const allProductsCategory = {
      id: null,
      Value: "All Products",
      Image: { src: "/Images/Content/mh-registered-white.png", alt: "All Products" }
    };
  return <div className={styles.CarouselContainer}>
    {categories.map((category, i) => (
      <CategorySelectorItem key={i} index={i} category={category} categoryClicked={handleCategoryClick} />
    ))}

    <CategorySelectorItem key={"all-products"} index={categories.length} category={allProductsCategory  }  categoryClicked={() => handleCategoryClick(null)} />
  </div>
}

  return (
    <div className={styles.CategorySelectorContainer}>
         <div className={styles.Title}>Products</div>
      {/* <div className={styles.TitleBar}>
        <div className={styles.ProductsTitle}>Products</div>
      </div> */}
      {isMobile ? (
        <div className={styles.CarouselContainerOuter}>
          <MHCarousel
            itemcount={categories.length + 1}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
          >
            {categoryList()}
          </MHCarousel>
        </div>
  
      ) : (
        <div className={styles.CategorySelector}>
          {categories.map((category, i) => (
            <div
              className={`${styles.CategoryItem} ${
                selectedCategory === category ? styles.Selected : ""
              }`}
              key={i}
              onClick={() => handleCategoryClick(category)}
            >
              <div
                className={`${styles.CategoryItemCircle} ${
                  selectedCategory === category ? styles.Selected : ""
                }`}
              >
                <img
                  className={styles.CategoryItemImage}
                  src={
                    category.Image
                      ? category.Image.src
                      : `/Images/Content/mh-registered-white.png`
                  }
                  alt={category.Image?.alt}
                  onError={handleImgError}
                />
              </div>
              <div className={styles.CategoryItemLabel}>{category.Value}</div>
            </div>
          ))}
          <div
            className={`${styles.CategoryItem} ${
              selectedCategory === null ? styles.Selected : ""
            }`}
            key={"all-products"}
            onClick={() => handleCategoryClick(null)}
          >
            <div
              className={`${styles.CategoryItemCircle} ${
                selectedCategory === null ? styles.Selected : ""
              }`}
            >
              <img
                className={styles.CategoryItemImage}
                src={`/Images/Content/mh-registered-white.png`}
                alt={"All Products"}
                onError={handleImgError}
              />
            </div>
            <div className={styles.CategoryItemLabel}>All Products</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CategorySelector;
